import { atom } from 'jotai';

/**
 * Atom to track the expected number of MQTT subscriptions for the current page/context.
 * Pages that require subscriptions should set this on mount and reset to 0 on unmount.
 * Default is 0 (no subscriptions expected).
 */
export const expectedSubscriptionsAtom = atom<number>(0);
